// extracted by mini-css-extract-plugin
module.exports = {"container":"Lz-z","productName":"Mz-z","modal":"Nz-z","dimensions":"Oz-z","recipientEmail":"Pz-z","lowStock":"Qz-z","recommendedFit":"Rz-z"};